"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { CartCustomQuantity } from "./CartCustomQuantity";
import { QuantitySelect } from "./QuantitySelect";
export interface Props {
  item: CartItemOutputDto;
  customOptionIsSelected: boolean;
  hasNonPresetQuantity: boolean;
  isSingleQuantity: boolean;
  showQuantityError: boolean;
  onCustomSelected: () => void;
  onPresetQuantityChange: (quantity: number) => void;
  onCustomQuantityApply: (quantity: number) => void;
}
const QUANTITY_ERROR_MESSAGE = "We couldn't update the quantity. Please try again.";
export function CartItemQuantity(t0) {
  const $ = _c(16);
  const {
    item,
    customOptionIsSelected,
    hasNonPresetQuantity,
    isSingleQuantity,
    showQuantityError,
    onCustomSelected,
    onPresetQuantityChange,
    onCustomQuantityApply
  } = t0;
  if (isSingleQuantity) {
    return null;
  }
  let t1;
  if ($[0] !== customOptionIsSelected || $[1] !== item || $[2] !== onCustomSelected || $[3] !== onPresetQuantityChange) {
    t1 = <QuantitySelect item={item} onQuantityChange={onPresetQuantityChange} onCustomSelected={onCustomSelected} isCustomSelected={customOptionIsSelected} />;
    $[0] = customOptionIsSelected;
    $[1] = item;
    $[2] = onCustomSelected;
    $[3] = onPresetQuantityChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== customOptionIsSelected || $[6] !== hasNonPresetQuantity || $[7] !== item || $[8] !== onCustomQuantityApply) {
    t2 = customOptionIsSelected && <CartCustomQuantity item={item} onApply={onCustomQuantityApply} prefill={hasNonPresetQuantity} />;
    $[5] = customOptionIsSelected;
    $[6] = hasNonPresetQuantity;
    $[7] = item;
    $[8] = onCustomQuantityApply;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== showQuantityError) {
    t3 = showQuantityError && <p role="alert" className="text-sm text-destructive">{QUANTITY_ERROR_MESSAGE}</p>;
    $[10] = showQuantityError;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <div className="flex flex-col gap-2">{t1}{t2}{t3}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}